import { ScrollableTabs } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import Product from '@/metrics/components/Product/Product'
import ProductType from '@/metrics/components/ProductType/ProductType'
import ProductTypeTableHeader from '@/metrics/components/ProductTypeTableHeader/ProductTypeTableHeader'
import Variant from '@/metrics/components/Variant/Variant'
import { groupByValues } from '@/metrics/constants'

import useProductTabs from './hooks/useProductTabs'
import ProductsListSkeleton from './ProductsListSkeleton/ProductsListSkeleton'
import SizingWidgetBanner from './SizingWidgetBanner/SizingWidgetBanner'
import { productsCardTabs } from './constants'
import * as Styles from './styles'

const ProductsList = ({
  products,
  productsFilters,
  onChangeProductsFilters,
  loading,
  onClickProduct,
  onClickVariant,
  onClickCategory,
  onClickType,
  onClickCollection,
  salesOrdersDataActivated,
  carbonOffset,
  isUnifiedDashboard,
  sizeRecommendationsCount,
  rateLabel,
}) => {
  const { selectedTab, setSelectedTab, filteredProducts, tabs } = useProductTabs(products, sizeRecommendationsCount)

  const getOnClickHandler = (onClick, index) => {
    if (typeof onClick === 'function') {
      return () => onClick(index)
    }
  }

  const handleSort = value => {
    const filterValueWithOrdering = productsFilters?.ordering === value ? `-${value}` : value
    onChangeProductsFilters({ ...productsFilters, ordering: filterValueWithOrdering })
  }

  const isSortingEnabled = typeof onChangeProductsFilters === 'function'

  if (loading) return <ProductsListSkeleton />
  if (!filteredProducts?.length) return <NoResultsFound />

  return (
    <Styles.MainContainer>
      {sizeRecommendationsCount > 0 && (
        <Styles.TabsContainer>
          <ScrollableTabs tabs={tabs} value={selectedTab} onChange={setSelectedTab} />
        </Styles.TabsContainer>
      )}
      {selectedTab === productsCardTabs.sizingIssues && <SizingWidgetBanner />}
      <div>
        <ProductTypeTableHeader
          type={productsFilters?.groupBy}
          salesOrdersDataActivated={salesOrdersDataActivated}
          onSort={isSortingEnabled && handleSort}
          orderBy={productsFilters?.ordering}
          rateLabel={rateLabel}
        />
        <Styles.TableContainer carbonOffset={carbonOffset}>
          {productsFilters?.groupBy === groupByValues.products &&
            filteredProducts?.map((product, index) => (
              <Product
                key={index}
                product={{ ...product, index: index + 1 }}
                onClick={getOnClickHandler(onClickProduct, product.originalPosition)}
                salesOrdersDataActivated={salesOrdersDataActivated}
                isUnifiedDashboard={isUnifiedDashboard}
                sizeRecommendationsActivated={sizeRecommendationsCount > 0}
              />
            ))}

          {productsFilters?.groupBy === groupByValues.variants &&
            filteredProducts?.map((variant, index) => (
              <Variant
                key={index}
                variant={{ ...variant, index: index + 1 }}
                onClick={getOnClickHandler(onClickVariant, variant.originalPosition)}
                salesOrdersDataActivated={salesOrdersDataActivated}
                sizeRecommendationsActivated={sizeRecommendationsCount > 0}
              />
            ))}

          {productsFilters?.groupBy === groupByValues.categories &&
            filteredProducts?.map((category, index) => (
              <ProductType
                key={index}
                productType={{ ...category, index: index + 1 }}
                onClick={getOnClickHandler(onClickCategory, category.originalPosition)}
                salesOrdersDataActivated={salesOrdersDataActivated}
                sizeRecommendationsActivated={sizeRecommendationsCount > 0}
              />
            ))}

          {productsFilters?.groupBy === groupByValues.types &&
            filteredProducts?.map((type, index) => (
              <ProductType
                key={index}
                productType={{ ...type, index: index + 1 }}
                onClick={getOnClickHandler(onClickType, type.originalPosition)}
                salesOrdersDataActivated={salesOrdersDataActivated}
                sizeRecommendationsActivated={sizeRecommendationsCount > 0}
              />
            ))}
          {productsFilters?.groupBy === groupByValues.collections &&
            filteredProducts?.map((collection, index) => (
              <ProductType
                key={index}
                productType={{ ...collection, index: index + 1 }}
                onClick={getOnClickHandler(onClickCollection, collection.originalPosition)}
                salesOrdersDataActivated={salesOrdersDataActivated}
                sizeRecommendationsActivated={sizeRecommendationsCount > 0}
              />
            ))}
        </Styles.TableContainer>
      </div>
    </Styles.MainContainer>
  )
}

export default ProductsList
